import { jsonp, ajax, loadScript, cookie } from '@ifeng/ui_base';
import { formatImage, formatUrl } from '@ifeng/public_method';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
let apiBaseUrl = apiUrl;
let carBaseUrl = '//api.auto.ifeng.com'; // '//10.90.3.81:8080';
/* eslint-enable no-undef */

if (/\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/c';
}

const md5 = require('md5');

// const createJsonpCallbackName = (str, num) => {
//     num = num ? num : 0;
//     let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

//     while (window[jsonpCallbackName]) {
//         num++;
//         jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
//     }

//     return jsonpCallbackName;
// };

const host = window.location.host;

// 获取推荐内容评论数
const getRecommend = async () => {
    const result = await jsonp(`${apiBaseUrl}/api/content/graphic/recommend/getRecommend`, {
        jsonpCallback: 'getRecommend',
        cache: false,
    });

    let recommendData = [];

    if (result.data) {
        const { data, count } = result.data;

        recommendData = data.map((item, index) => ({
            id: item.id,
            title: item.title,
            url: formatUrl(item.pcUrl),
            pcUrl: item.pcUrl,
            count: count[index],
            createtime:
                item.createtime.split('-')[0] < 2018
                    ? item.createtime
                    : `${item.createtime.split('-')[1]}-${item.createtime.split('-')[2]}`,
            thumbnailpic:
                item.sourceFrom === 'video' ? formatImage(item.postUrl, 144, 80) : formatImage(item.thumbnail, 144, 80),
            source: item.sourceFrom === 'video' ? item.mediaName : item.source,
            sourceFrom: item.sourceFrom,
        }));
    }

    return recommendData;
};

// 获取文章评论数
const getCommentCount = async url => {
    const { schemaCheck } = await import('./validate');

    let data = await jsonp('//comment.ifeng.com/get/count', {
        data: {
            format: 'js',
            docurl: url,
        },
        jsonpCallback: 'getCommentCount',
        cache: false,
    });
    const requestUrl = `comment.ifeng.com/get/count?format=js&docurl=${url}&callback=getCommentCount`;

    data = schemaCheck(data, 'commentCountSchema', requestUrl);

    return data ? data : null;
};

// 获取轮播图数据
const getSlidesData = async attachmentId => {
    const { schemaCheck } = await import('./validate');

    // let data = await ajax(`/c/api/content/graphic/getSlides/${attachmentId}`);
    let data = await jsonp(`${apiBaseUrl}/api/content/graphic/getSlides/${attachmentId}/callback`, {
        jsonpCallback: 'callback',
        cache: false,
    });

    const requestUrl = `${apiBaseUrl}/api/content/graphic/getSlides/${attachmentId}`;

    data = schemaCheck(data.data, 'slidesDataSchema', requestUrl);

    let slidesData = null;

    if (data) {
        slidesData = {
            url: data.commentUrl,
            slideData: JSON.parse(data.slideData).image,
        };
    }

    return slidesData;
};

// 获取文章推荐数
const getVoteNum = async url => {
    const { schemaCheck } = await import('./validate');

    let data = await jsonp('//survey.news.ifeng.com/api/getaccumulatorweight', {
        data: {
            format: 'js',
            key: url,
            serviceid: 2,
        },
        jsonpCallback: 'getaccumulator',
        cache: false,
    });
    const requestUrl = `//survey.news.ifeng.com/api/getaccumulatorweight?format=js&key=${url}&callback=getaccumulator`;

    data = schemaCheck(data.data, 'voteNumSchema', requestUrl);

    return data ? data : null;
};

// 文章推荐操作
const vote = async url => {
    const data = await jsonp('//survey.news.ifeng.com/api/accumulator', {
        data: {
            format: 'js',
            key: url,
        },
        jsonpCallback: 'accumulator',
        cache: false,
    });

    return data.code === 1;
};

// 获取热门文章数据
const getArticle = async () => {
    const data = await ajax('/c/api/content/graphic/article');

    let articleData = [];

    if (data.data) {
        articleData = data.data.slice(0, 10).map(item => ({
            url: formatUrl(item.url),
            title: item.title,
            img: item.img === '' ? '' : formatImage(item.img, 100, 56),
        }));
    }

    return articleData;
};

// 获取精彩视频数据
const getVideo = async () => {
    const data = await jsonp(`${apiBaseUrl}/api/content/graphic/video/getVideo`, {
        jsonpCallback: 'getVideo',
        cache: false,
    });

    let videoData = [];

    if (data.data) {
        videoData = data.data.slice(0, 10).map(item => ({
            url: formatUrl(item.url),
            title: item.title,
            img: item.img === '' ? '' : formatImage(item.img, 100, 56),
        }));
    }

    return videoData;
};

// 获取凤凰无线数据
const getWirelessData = async () => {
    const { schemaCheck } = await import('./validate');

    let data = await jsonp('//ios.yc.ifeng.com/api/cmsbook?v=5.4.11.1', {
        jsonpCallback: 'getWirelessData',
        cache: false,
    });

    const requestUrl = 'ios.yc.ifeng.com/api/cmsbook?v=5.4.11.1&callback=getWirelessData';

    data = schemaCheck(data, 'wirelessDataSchema', requestUrl);

    for (const item of data) {
        item.image_url = formatImage(item.image_url, 140, 80);
        item.link_url = formatUrl(item.link_url);
    }

    return data ? data : null;
};

// 获取调查数据
const getSurveyData = async id => {
    const { schemaCheck } = await import('./validate');

    let data = await jsonp('//sv.ifeng.com/index.php/survey/getdata', {
        data: {
            id,
        },
        jsonpCallback: 'getSurveyData',
        cache: false,
    });
    const requestUrl = `sv.ifeng.com/index.php/survey/getdata?id=${id}&callback=getSurveyData`;

    data = schemaCheck(data, 'surveyDataSchema', requestUrl);

    return data ? data : null;
};

// 提交调查数据
const postSurveyData = async (param, id) => {
    return await jsonp(`//sv.ifeng.com/index.php/survey/postsurvey?${param}`, {
        data: {
            id,
        },
        jsonpCallback: 'postSurveyData',
        cache: false,
    });
};

// 幻灯 获取最后一帧图集推荐
const getPicRecom = async channel => {
    const { schemaCheck } = await import('./validate');

    // let data = await ajax(`/c/api/content/graphic/slide/${channel}`);
    let data = await jsonp(`${apiBaseUrl}/api/content/graphic/slide/${channel}/callback`, {
        jsonpCallback: 'callback',
        cache: false,
    });
    const requestUrl = `${apiBaseUrl}/api/content/graphic/slide/${channel}`;

    data = schemaCheck(data.data, 'picRecomSchema', requestUrl);

    let picRecom = null;

    if (data) {
        picRecom = data.map(item => ({
            url: item.url,
            title: item.title,
            img: item.img ? formatImage(item.img, 171, 103) : '',
            publishTime: item.publishTime,
        }));
    }

    return picRecom;
};

// 原创 获取栏目往期文章
const getSection = async (base62Id, searchPath) => {
    // const data = await ajax(`/c/api/content/original/getSection/${searchPath}`);

    let data = await jsonp(`${apiBaseUrl}/api/content/original/getSection/${searchPath}/callback`, {
        jsonpCallback: 'callback',
        cache: false,
    });

    let list = data.data.filter(item => item.base62Id !== base62Id);

    list = list.slice(0, 10).map(item => ({
        url: formatUrl(item.url),
        title: item.title,
    }));

    return list;
};

// 获取分享二维码
const getQrCode = async url => {
    return await jsonp(`//qrcode.ifeng.com/qrcode.php?url=${url}?_share=weixin`, {
        jsonpCallback: 'getQrCode',
        cache: false,
    });
};

// 幻灯统计
// const requestUrl = (datatype, value) => {
//     let re_url = '//stadig.ifeng.com/actsta.js?';
//     const fa_param = window.getFaParams();
//     let r = [];
//     const pt = encodeURIComponent('hdtype=high');
//     const url = encodeURIComponent(window.location.href);
//     const time = new Date().getTime();

//     r.push(`datatype=${datatype}`);
//     r.push(`value=${value ? value : ''}`);
//     r.push(`uri=${url}`);
//     r.push('ref=');
//     r.push(`uid=${fa_param.uid ? fa_param.uid : ''}`);
//     r.push(`sid=${fa_param.sid ? fa_param.sid : ''}`);
//     r.push(`time=${time}`);
//     r.push(`ci=${fa_param.ci ? fa_param.ci : ''}`);
//     if (datatype === 'share') {
//         r.push(`pt=${pt ? pt : ''}`);
//     }
//     r = r.join('&');
//     re_url += r;
// };

const requestTongji = async (datatype, value) => {
    const fa_param = window.getFaParams();
    const url = window.location.href;
    const time = new Date().getTime();
    const pt = 'hdtype=high';

    try {
        await loadScript('//stadig.ifeng.com/actsta.js', {
            data: {
                datatype,
                value: value ? value : '',
                uri: url,
                ref: '',
                uid: fa_param.uid ? decodeURIComponent(fa_param.uid) : '',
                sid: fa_param.sid ? decodeURIComponent(fa_param.sid) : '',
                time,
                ci: fa_param.ci ? decodeURIComponent(fa_param.ci) : '',
                pt: datatype === 'share' ? pt : '',
            },
            cache: false,
        });
    } catch (e) {
        console.error(e);
    }
};

// // 获取城市详情
const getCityInfo = async () => {
    let data = await jsonp('//api.auto.ifeng.com/cms/api/cityinfo', {
        jsonpCallback: 'callback',
        cache: false,
    });
    let cityArr = [
        ['a'],
        ['b'],
        ['c'],
        ['d'],
        ['e'],
        ['f'],
        ['g'],
        ['h'],
        ['j'],
        ['k'],
        ['l'],
        ['m'],
        ['n'],
        ['p'],
        ['q'],
        ['s'],
        ['t'],
        ['w'],
        ['x'],
        ['y'],
        ['z'],
    ];
    const cityLetter = [];

    for (const item of cityArr) {
        cityLetter.push(item[0].toUpperCase());
    }

    for (const item of data) {
        for (const cityIndex of cityArr) {
            // cityLetter.push(cityIndex[0]);
            if (cityIndex[0].toLowerCase() === item.pinyin.charAt(0).toLowerCase()) {
                cityIndex.push(`${item.name} , ${item.pinyin}, ${item.citycode}`);
            }
        }
    }

    return {
        cityArr,
        cityLetter,
    };
};

// // 获取厂商信息
const getFirmInfo = async id => {
    let data = await jsonp(`${carBaseUrl}/api/getSerialCroBySerialId.do?serialId=${id}`, {
        jsonp: 'callbackparam',
        cache: false,
    });

    return data;
};

// // 获取车系详情
const getSeriesInfo = async id => {
    let data = await jsonp(`${carBaseUrl}/api/getSerialInfoBySerialId.do?serialId=${id}`, {
        jsonp: 'callbackparam',
        cache: false,
    });

    if (data) {
        data.outer = data.outer ? formatImage(data.outer, 120, 80) : '';
        data.inner = data.inner ? formatImage(data.inner, 120, 80) : '';
    }

    return data;
};

// // 获取最热促销
const getDealer = async (cityId, id) => {
    let data = await jsonp(` //dealer.auto.ifeng.com/api/getDealerInfoByCompanyType?cityId=${cityId}&serialId=${id}`, {
        jsonpCallback: 'dealer',
        cache: false,
    });
    let dealerData = [];

    for (let i = 0; i < data.length; i++) {
        for (let key in data[i]) {
            if (data[i][key][0] && data[i][key][0] !== null) {
                dealerData.push(data[i][key]);
            }
        }
    }

    return dealerData;
};

// 获取大家都在看数据
const getSeriesRankList = async id => {
    let dataurl = id
        ? `//api.auto.ifeng.com/api/getSerialRefRecommen.do?serialId=${id}&callbackparam=asd123`
        : '//api.auto.ifeng.com/api/getSerialRefRecommen.do?callbackparam=asd123';

    let data = await jsonp(dataurl, {
        jsonpCallback: 'asd123',
        cache: false,
    });

    return data;
};

const getCarSerial = async id => {
    const data = await ajax(`/c/api/content/graphic/getCarSerial/${id}`);

    if (data.relatedArticleData) {
        data.relatedArticleData = data.relatedArticleData.map(item => ({
            url: formatUrl(item.url),
            title: item.title,
            columnName: item.columnName,
            img: item.img ? formatImage(item.img, 140, 100) : '',
            searchPath: item.searchPath,
        }));
    } else {
        data.relatedArticleData = [];
    }

    return data;
};
// 获取品牌
const getBrandandSerialList = async () => {
    const data = await jsonp(`${carBaseUrl}/api/getBrandandSerialList.do`);

    return data;
};
// 获取快捷询价
const getFastXunjia = async serialId => {
    const data = await jsonp(
        `//api.auto.ifeng.com/api/getSerialRecommen.do?serialId=${serialId}&count=4&key='1366879516497_akt7i54447'`,
        {
            jsonp: 'callbackparam',
            jsonpCallback: 'callbackfun',
        },
    );

    return data;
};

// 获取询价新闻
const getXunjiaNews = async (serialId, cityid) => {
    const data = await jsonp(
        `//api.auto.ifeng.com/app/api/city/xunjia_alert_news.php?s_id=${serialId}&citycode=${cityid}`,
        {
            jsonp: 'callback',
            jsonpCallback: 'callbackfun',
        },
    );

    return data;
};

const getMessageHander = async sendData => {
    const data = await jsonp('http://dealer.auto.ifeng.com/sms/messageHander', {
        jsonp: 'callbackparam',
        jsonpCallback: 'callbackfun',
        data: {
            'messageInfo.userName': sendData.userName,
            'messageInfo.mobile': sendData.mobile,
            'messageInfo.cityName': sendData.cityName,
            'messageInfo.province': sendData.province,
            'messageInfo.city': sendData.city,
            'messageInfo.brandId': sendData.brandId,
            'messageInfo.serialId': sendData.serialId,
            'messageInfo.carId': sendData.carId,
            'messageInfo.carName': sendData.carName,
            'messageInfo.brandName': sendData.brandName,
            'messageInfo.serialName': sendData.serialName,
            'messageInfo.contactType': sendData.contactType,
            'messageInfo.gender': sendData.gender,
        },
    });

    return data;
};

const getPriceInterval = async (serialId, cityid) => {
    const data = await jsonp(
        `//dealer.auto.ifeng.com/api/getPriceIntervalBySerialIdAndCity?serialId=${serialId}&cityId=${cityid}`,
        {
            jsonp: 'callback',
            jsonpCallback: 'callbackfun',
        },
    );

    return data;
};
const getIp = async () => {
    cookie.set('auto_iploc', ''); // 清cookie
    let auto_iploc = cookie.get('auto_iploc');
    const cityData = await ajax('//s.auto.ifeng.com/locip/getLocUp');

    if (cityData) {
        const jsond = cityData;
        let ocode = parseInt(jsond.code);
        let ip = jsond.ip;
        let iploc_name = jsond.name;
        let ifengcookie = '';

        if (
            jsond === null ||
            jsond === undefined ||
            jsond.length < 1 ||
            jsond.code === undefined ||
            jsond.code === null ||
            jsond.code === ''
        ) {
            ifengcookie = '110000';
            iploc_name = '北京';
            alert('当前城市暂时无法识别，请手动切换！');
        } else if (ocode < 0) {
            ifengcookie = '110000';
            iploc_name = '北京';
            alert('当前城市暂时无法识别，请手动切换！');
        } else {
            auto_iploc = ifengcookie = jsond.code;
        }
        auto_iploc = ifengcookie;
        // 就近原则
        let iploc_code = auto_iploc.replace(/cn/gi, '');
        let cityname = '';
        let citycode = '';
        let citypinyin = '';
        const cityAllData = await jsonp('//api.auto.ifeng.com/cms/api/cityInfo_new', {
            data: {
                match: 1,
                citycode: iploc_code ? iploc_code : '110000',
            },
        });

        if (cityAllData) {
            let data = cityAllData;
            let jjcode = '';

            if (data.status === 0) {
                jjcode = '110000';
                cityname = '北京';
                citycode = '110000';
                citypinyin = 'beijing';
            } else if (data.data && data.data[0].match.length > 0) {
                jjcode = data.data[0].match[0].match_citycode; // 就近原则城市编码
                cityname = data.data[0].match[0].match_name;
                citycode = data.data[0].match[0].match_citycode;
                citypinyin = data.data[0].match[0].match_pinyin;
            } else {
                jjcode = '110000';
                cityname = '北京';
                citycode = '110000';
                citypinyin = 'beijing';
            }

            citycode = citycode ? citycode : 110000;
            cityname = cityname ? cityname : '北京';
            citypinyin = citypinyin ? citypinyin : 'beijing';
            // allData.curCity = {
            //     citycode: 340800,
            //     cityname: '安庆',
            //     citypinyin: 'anqing',
            // };
            let exp = new Date();

            exp.setTime(exp.getTime() + 120 * 60 * 1000);
            cookie.set('auto_iploc', jjcode, {
                expires: exp,
            });

            return {
                citycode,
                cityname,
                citypinyin,
            };
        }
    }
};

export {
    getRecommend,
    getCommentCount,
    getSlidesData,
    getVoteNum,
    vote,
    getArticle,
    getVideo,
    getWirelessData,
    getSurveyData,
    postSurveyData,
    getPicRecom,
    getSection,
    getQrCode,
    requestTongji,
    getCarSerial,
    getSeriesRankList,
    getSeriesInfo,
    getFirmInfo,
    getCityInfo,
    getDealer,
    getBrandandSerialList,
    getFastXunjia,
    getXunjiaNews,
    getMessageHander,
    getPriceInterval,
    getIp,
};
